export default {

  getGroupId(groups, members) {
    const membersSignature = this.getGroupingSignature(members);
    const find = groups.filter(group => {
      const groupSignature = this.getGroupingSignature(group.members);
      return membersSignature === groupSignature;
    });
    if(find.length > 0) {
      return find[0].id;
    }
    return null
  },

  getGroupSignature(group) {
    return '['+group.map(option => option.id).sort().join(',')+']'
  },

  getGroupingSignature(grouping) {
    return grouping.map(group => this.getGroupSignature(group)).sort().join('')
  },

};